import React from 'react';
import { Footer } from '@qbe/ads-core';
import { useContent, useContentContext } from '@qbe/dfc-content';
import { styled } from '@mui/material/styles';

// This terrible css is just because ADS doesn't have a correct looking footer
// remove this css when footer is styled properly
// https://qbe-appservices.atlassian.net/browse/AD1-310?focusedCommentId=916979
const StyledFooter = styled(Footer)`
  [class*='-FooterWrapper'] {
    display: none;
  }

  [class*='-FooterTextsContainer'] {
    background-color: inherit;
    border: 0;
  }

  padding-top: 0 !important;
  padding-bottom: 0 !important;
`;

function CustomerFooter() {
  const { getJSXContent } = useContent({
    context: useContentContext(),
  });

  return (
    <StyledFooter
      variant="compressed"
      surfaceColour="onlight"
      linkColumns={[]}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      footerTexts={[getJSXContent('footer.html') as any]}
    />
  );
}

export default CustomerFooter;
